(function () {
  /* ---------- money ---------- */
  function formatMoney(cents, format) {
    var fmt = format || "${{amount}}";
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var kind = m ? m[1] : "amount";
    function group(n, dec, thou, sep) {
      var parts = (cents / 100).toFixed(dec).split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.length > 1 ? parts[0] + sep + parts[1] : parts[0];
    }
    var val;
    switch (kind) {
      case "amount_no_decimals": val = group(cents, 0, ",", "."); break;
      case "amount_with_comma_separator": val = group(cents, 2, ".", ","); break;
      case "amount_no_decimals_with_comma_separator": val = group(cents, 0, ".", ","); break;
      default: val = group(cents, 2, ",", ".");
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, val);
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }

  /* ---------- product buy box ---------- */
  document.querySelectorAll("[data-lc-product]").forEach(function (root) {
    var section = root.parentElement;
    var dataEl = section.querySelector("[data-lc-data]");
    if (!dataEl) return;
    var D = JSON.parse(dataEl.textContent);
    var q = function (s) { return section.querySelector(s); };
    var variant = D.variants.find(function (v) { return v.id === D.selected; }) || D.variants[0];
    var protectBox = q("[data-lc-protect]");
    var sets = [];

    function players(v) { var m = String(v.title).match(/\d+/); return m ? parseInt(m[0], 10) : D.playersPerSet; }
    function setCount() { return Math.max(1, Math.round(players(variant) / (D.playersPerSet || 2))); }
    function total() { return variant.price + (protectBox && protectBox.checked && D.protect ? D.protect.price : 0); }
    function setsText() {
      if (!D.colours.length) return "";
      var counts = {};
      sets.forEach(function (i) { var n = D.colours[i].name; counts[n] = (counts[n] || 0) + 1; });
      return Object.keys(counts).map(function (k) { return (sets.length > 1 ? counts[k] + " × " : "") + k; }).join(", ");
    }

    /* gallery */
    var thumbs = q("[data-lc-thumbs]"), view = q("[data-lc-view]");
    if (thumbs) thumbs.addEventListener("click", function (e) {
      var b = e.target.closest(".thumb"); if (!b) return;
      thumbs.querySelectorAll(".thumb").forEach(function (t) { t.setAttribute("aria-pressed", t === b ? "true" : "false"); });
      view.innerHTML = '<img src="' + b.dataset.src + '" alt="' + (b.dataset.alt || "") + '">';
    });

    function renderPacks() {
      var el = q("[data-lc-packs]"); if (!el) return;
      var base = D.variants[0].price / players(D.variants[0]);
      el.innerHTML = D.variants.map(function (v, i) {
        var per = v.price / players(v), save = Math.round((1 - per / base) * 100), badge = D.badges[i];
        return '<button type="button" class="pack" role="radio" aria-checked="' + (v.id === variant.id) + '" data-id="' + v.id + '"' + (v.available ? "" : " disabled") + '>' +
          (badge ? '<span class="tag' + (i === 2 ? " v" : "") + '">' + esc(badge) + "</span>" : "") +
          '<span class="radio"></span><span><span class="t">' + esc(v.title) + '</span><br><span class="d">' +
          players(v) + " guns + " + players(v) + " vests" + (save > 0 ? " · save " + save + "% per player" : "") +
          (v.available ? "" : ' · <span class="soldout">Sold out</span>') + "</span></span>" +
          '<span class="p">' + formatMoney(v.price, D.moneyFormat) + '<span class="pp">' + formatMoney(Math.round(per), D.moneyFormat) + " / player</span></span></button>";
      }).join("");
    }
    function renderSets() {
      var el = q("[data-lc-sets]"); if (!el || !D.colours.length) return;
      var n = setCount();
      while (sets.length < n) sets.push(0);
      sets.length = n;
      q("[data-lc-setslabel]").textContent = n > 1 ? "Colour sets (" + n + " sets of " + D.playersPerSet + ")" : "Colour set";
      el.innerHTML = sets.map(function (sel, i) {
        return '<div class="setrow" role="group" aria-label="Set ' + (i + 1) + ' colour">' + (n > 1 ? '<span class="n">Set ' + (i + 1) + "</span>" : "") +
          D.colours.map(function (c, ci) {
            return '<button type="button" class="chip" data-set="' + i + '" data-c="' + ci + '" aria-pressed="' + (sel === ci) + '"><span class="dots">' +
              c.dots.map(function (d) { return '<i style="background:' + esc(d) + '"></i>'; }).join("") + "</span>" + esc(c.name) + "</button>";
          }).join("") + "</div>";
      }).join("");
    }
    function update() {
      renderPacks(); renderSets();
      var p = players(variant);
      q("[data-lc-bigprice]").textContent = formatMoney(variant.price, D.moneyFormat);
      q("[data-lc-perplayer]").textContent = D.variants.length > 1 ? formatMoney(Math.round(variant.price / p), D.moneyFormat) + " per player" : "";
      q("[data-lc-total]").textContent = formatMoney(total(), D.moneyFormat);
      var sub = q("[data-lc-stsub]"); if (sub) sub.textContent = variant.title === "Default Title" ? "" : variant.title;
      var sb = q("[data-lc-stickybuy]"); if (sb) sb.textContent = D.buyLabel + " · " + formatMoney(total(), D.moneyFormat);
      var buy = q("[data-lc-buy]"); buy.disabled = !variant.available; buy.textContent = variant.available ? D.buyLabel : "Sold out";
      if (history.replaceState && document.body.classList.contains("template-product")) {
        var u = new URL(location.href); u.searchParams.set("variant", variant.id); history.replaceState(null, "", u);
      }
    }
    section.addEventListener("click", function (e) {
      var pk = e.target.closest(".pack[data-id]");
      if (pk && !pk.disabled) { variant = D.variants.find(function (v) { return v.id === +pk.dataset.id; }); update(); return; }
      var ch = e.target.closest("[data-set]");
      if (ch) { sets[+ch.dataset.set] = +ch.dataset.c; renderSets(); }
    });
    if (protectBox) protectBox.addEventListener("change", update);

    /* buy now */
    function buy() {
      var btn = q("[data-lc-buy]"), sbtn = q("[data-lc-stickybuy]"), err = q("[data-lc-error]");
      if (!variant.available) return;
      btn.disabled = true; if (sbtn) sbtn.disabled = true; err.hidden = true;
      var props = {};
      if (D.colours.length) props["Colour sets"] = setsText();
      var items = [{ id: variant.id, quantity: 1, properties: props }];
      if (protectBox && protectBox.checked && D.protect) items.push({ id: D.protect.id, quantity: 1 });
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
      var start = D.clearCart ? fetch(root + "cart/clear.js", { method: "POST", headers: { "Content-Type": "application/json" } }) : Promise.resolve();
      start.then(function () {
        return fetch(root + "cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items: items }) });
      }).then(function (r) {
        return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || "Couldn't add to cart"); return j; });
      }).then(function () {
        location.href = D.goToCheckout ? root + "checkout" : root + "cart";
      }).catch(function (e) {
        err.textContent = e.message + ". Please try again."; err.hidden = false;
        btn.disabled = false; if (sbtn) sbtn.disabled = false;
      });
    }
    q("[data-lc-buy]").addEventListener("click", buy);
    var sticky = q("[data-lc-sticky]"), stickyBtn = q("[data-lc-stickybuy]");
    if (stickyBtn) stickyBtn.addEventListener("click", buy);
    if (sticky && "IntersectionObserver" in window) {
      new IntersectionObserver(function (en) {
        sticky.classList.toggle("on", !en[0].isIntersecting);
        document.body.classList.toggle("has-sticky", !en[0].isIntersecting);
      }).observe(q("[data-lc-buy]"));
    }
    update();
  });

  /* ---------- see it in action demo ---------- */
  document.querySelectorAll("[data-lc-demo]").forEach(function (demo) {
    var max = parseInt(demo.dataset.lives || "5", 10), lives = max, busy = false;
    var livesEl = demo.querySelector("[data-lives]"), beam = demo.querySelector(".beam"), vest = demo.querySelector(".vest"),
      out = demo.querySelector(".out"), btn = demo.querySelector("[data-fire]"), msg = demo.querySelector("[data-msg]");
    var startMsg = msg.textContent;
    function draw() { livesEl.innerHTML = "Red " + Array.from({ length: max }, function (_, i) { return '<i class="' + (i < lives ? "" : "off") + '"></i>'; }).join(""); }
    btn.addEventListener("click", function () {
      if (lives === 0) { lives = max; draw(); out.hidden = true; btn.textContent = "Fire"; msg.textContent = startMsg; return; }
      if (busy) return; busy = true;
      beam.classList.remove("fire"); void beam.offsetWidth; beam.classList.add("fire");
      setTimeout(function () {
        vest.classList.remove("hit"); void vest.offsetWidth; vest.classList.add("hit"); lives--; draw();
        msg.textContent = lives ? "Hit! Vest flashes and buzzes. " + lives + (lives === 1 ? " life" : " lives") + " left." : "Red is out. Blue team wins the round.";
        if (!lives) { out.hidden = false; btn.textContent = "Play again"; }
        setTimeout(function () { vest.classList.remove("hit"); busy = false; }, 350);
      }, 200);
    });
    draw();
  });
})();
